import { Link } from "react-router-dom";
import { MessageCircle, CalendarCheck, MapPin, Home, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { CLINIC, CLINIC_PHOTOS, telLink, whatsappLink, HOME_VISIT_WHATSAPP_MSG } from "../../data/site";

export const HomeVisitBanner = () => (
  <section className="relative overflow-hidden bg-dash-ink" data-testid="home-visit-banner">
    <div className="grain" />
    <div className="pointer-events-none absolute -top-24 -left-24 h-80 w-80 rounded-full bg-dash-teal/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-dash-gold/10 blur-3xl" />

    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-16 md:py-20 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-dash-teal/15 border border-dash-teal/30 px-4 py-1.5 text-xs uppercase tracking-[0.18em] font-accent font-semibold text-dash-teal">
            <Home className="h-3.5 w-3.5" /> Home Visit Service
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-bold text-white leading-[1.05]">
            Physiotherapy at Your Doorstep
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-3 text-lg font-semibold text-dash-gold">
            Home Visit Physiotherapy in Belpahar &amp; Jharsuguda
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-4 text-white/70 leading-relaxed max-w-2xl">
            Can't visit the clinic? Our physiotherapy team brings professional rehabilitation care to your home.
            Home visit physiotherapy is available for patients in Belpahar and the Jharsuguda area.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
            <Link
              to="/contact?service=Home%20Visit%20Physiotherapy"
              data-testid="banner-book-home-visit"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-dash-teal px-7 py-4 font-semibold text-white shadow-lg shadow-dash-teal/25 transition-all duration-300 hover:bg-white hover:text-dash-ink hover:-translate-y-0.5"
            >
              <CalendarCheck className="h-5 w-5" /> Book a Home Visit
            </Link>
            <a
              href={whatsappLink(HOME_VISIT_WHATSAPP_MSG)}
              target="_blank"
              rel="noreferrer"
              data-testid="banner-whatsapp"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5"
            >
              <MessageCircle className="h-5 w-5" /> WhatsApp Us
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/60">
            <span className="inline-flex items-center gap-1.5"><Phone className="h-4 w-4 text-dash-teal" /> Phone: <a href={telLink} className="text-white font-medium hover:text-dash-teal">{CLINIC.phone}</a></span>
            <span className="inline-flex items-center gap-1.5"><MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp: <a href={whatsappLink(HOME_VISIT_WHATSAPP_MSG)} target="_blank" rel="noreferrer" className="text-white font-medium hover:text-dash-teal">{CLINIC.whatsapp}</a></span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.1}>
          <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_rgb(0,0,0,0.35)]">
            <img src={CLINIC_PHOTOS.homeVisit} alt="Home visit physiotherapy session at a patient's home" className="h-[280px] md:h-[340px] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-dash-ink/50 to-transparent" />
            <div className="absolute bottom-4 left-4 flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-4 py-2 text-sm font-semibold text-dash-ink">
              <MapPin className="h-4 w-4 text-dash-teal" /> Belpahar &amp; Jharsuguda
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
